export const COLORS = [
  "Black",
  "Blue",
  "Brown",
  "Cream",
  "Gold",
  "Green",
  "Grey",
  "Multi-Color",
  "Orange",
  "Pink",
  "Purple",
  "Red",
  "Silver",
  "Tan",
  "Teal",
  "White",
  "Yellow"
] as const;

export const COLOR_LABELS: Record<string, string> = {
  "Black": "Черный",
  "Blue": "Синий",
  "Brown": "Коричневый",
  "Cream": "Кремовый",
  "Gold": "Золотой",
  "Green": "Зеленый",
  "Grey": "Серый",
  "Multi-Color": "Разноцветный",
  "Orange": "Оранжевый",
  "Pink": "Розовый",
  "Purple": "Фиолетовый",
  "Red": "Красный",
  "Silver": "Серебряный",
  "Tan": "Бежевый",
  "Teal": "Бирюзовый",
  "White": "Белый",
  "Yellow": "Желтый"
};

export const COLOR_HEX: Record<string, string> = {
  "Black": "#000000",
  "Blue": "#0066CC",
  "Brown": "#8B4513",
  "Cream": "#FFFDD0",
  "Gold": "#FFD700",
  "Green": "#228B22",
  "Grey": "#808080",
  "Multi-Color": "linear-gradient(90deg, #FF0000 0%, #FF7F00 16.67%, #FFFF00 33.33%, #00FF00 50%, #0000FF 66.67%, #4B0082 83.33%, #9400D3 100%)",
  "Orange": "#FF8C00",
  "Pink": "#FFC0CB",
  "Purple": "#800080",
  "Red": "#DC143C",
  "Silver": "#C0C0C0",
  "Tan": "#D2B48C",
  "Teal": "#008080",
  "White": "#FFFFFF",
  "Yellow": "#FFD700"
};

